import type React from 'react';

/**
 * A "mail being sent" icon in the lucide style (24 viewBox, stroke 2, round caps):
 * an envelope skewed to the right (italic-like) with three trailing motion lines
 * on its left (longest on top, shortest at the bottom) suggesting it flies right.
 *
 * Accepts the same props as any SVG icon — size it with a Tailwind `size-*` class.
 */
export const SendingMailIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		{...props}
	>
		<g transform="translate(2.55 0) skewX(-12)">
			<rect x="9" y="6" width="13" height="12" rx="2" />
			<path d="M9.7 7.5L15.5 11.8L21.3 7.5" />
		</g>
		<path d="M1 9h6" />
		<path d="M2 12h4" />
		<path d="M3 15h3" />
	</svg>
);
